const modeFreeCategories = [
  'counter-strike-global-offensive',
  'custom',
  'flick',
  'follow-through',
  'gauntlet',
  'speed',
  'tracking',
  'zig-zag',
  'net-train'
]

const specialGameModes = [ 'counter-strike-global-offensive', 'net-train' ]

export { modeFreeCategories, specialGameModes, }



// WEBPACK FOOTER //
// ./src/app/const/simulator.js